import type {
  CircleLayerSpecification,
  ExpressionSpecification,
  LayerSpecification,
} from 'maplibre-gl';

// Port of OfflineMapDataset.basemapTransitStopLayers in everything-app.
const stopColor: ExpressionSpecification = [
  'match',
  ['get', 'kind'],
  'bus_stop',
  '#2563eb',
  'bus_station',
  '#1d4ed8',
  'tram_stop',
  '#c2410c',
  '#6d28d9',
];

function circleStopLayer(
  id: string,
  kind: string,
  minzoom: number,
  radius: number
): CircleLayerSpecification {
  return {
    id,
    type: 'circle',
    source: 'protomaps',
    'source-layer': 'pois',
    minzoom,
    filter: ['==', ['get', 'kind'], kind],
    paint: {
      'circle-radius': radius,
      'circle-color': stopColor,
      'circle-stroke-width': 1.75,
      'circle-stroke-color': '#ffffff',
      'circle-opacity': 0.96,
      'circle-pitch-alignment': 'viewport',
    },
  };
}

export const transitStopLayers: LayerSpecification[] = [
  {
    id: 'everything-basemap-rail-stops',
    type: 'symbol',
    source: 'protomaps',
    'source-layer': 'pois',
    minzoom: 11,
    filter: ['in', ['get', 'kind'], ['literal', ['station', 'railway']]],
    layout: {
      'icon-image': 'train_station',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-padding': 2,
    },
  },
  circleStopLayer('everything-basemap-bus-stations', 'bus_station', 13, 5),
  circleStopLayer('everything-basemap-tram-stops', 'tram_stop', 14, 4),
  {
    id: 'everything-basemap-bus-stops',
    type: 'symbol',
    source: 'protomaps',
    'source-layer': 'pois',
    minzoom: 15,
    filter: ['==', ['get', 'kind'], 'bus_stop'],
    layout: {
      'icon-image': 'bus_stop',
      'icon-size': ['interpolate', ['linear'], ['zoom'], 15, 0.8, 17, 1],
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-padding': 2,
    },
  },
  {
    id: 'everything-basemap-transit-stop-labels',
    type: 'symbol',
    source: 'protomaps',
    'source-layer': 'pois',
    minzoom: 16,
    filter: [
      'in',
      ['get', 'kind'],
      [
        'literal',
        ['station', 'railway', 'bus_station', 'tram_stop', 'bus_stop'],
      ],
    ],
    layout: {
      'text-field': ['coalesce', ['get', 'name:pl'], ['get', 'name']],
      'text-font': ['Noto Sans Regular'],
      'text-size': 11,
      'text-offset': [0, 1.05],
      'text-anchor': 'top',
      'text-padding': 3,
      'text-optional': true,
      'symbol-sort-key': [
        'match',
        ['get', 'kind'],
        'station',
        1,
        'railway',
        1,
        'bus_station',
        2,
        'tram_stop',
        3,
        4,
      ],
    },
    paint: {
      'text-color': stopColor,
      'text-halo-color': 'rgba(255, 255, 255, 0.96)',
      'text-halo-width': 1.5,
      'text-halo-blur': 0.4,
    },
  },
];
